
import { defineComponent, reactive, toRefs, computed, onMounted, h } from 'vue'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
import f10ApiUS from '@/api/f10ApiUS'
import { isLocalDev } from '@/api/config'

import { useRoute } from 'vue-router'


export default defineComponent({
  components: { Table, Nodata },
  props: {
    token: { type: String, default: '' },
    itemdata: { type: Object, default: () => ({}) },
    pageSourceData: { type: Object, default: () => ({}) },
  },
  setup(props) {
    // 引入路由
    const route = useRoute()
    const pageData = reactive({
      allData: [] as any[],  // 存储所有数据
      columns: [
        {
          title: '资讯日期',
          dataIndex: 'ctime_str',
          key: 'ctime_str',
          width: '170px',
          customRender: ({ text }: any) => {
            if (!text) return '--'
            // 只显示年月日，去掉时分秒
            const date = new Date(text)
            if (isNaN(date.getTime())) return text
            return date.toLocaleDateString('zh-CN', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            })
          }
        },
        {
          title: '资讯标题',
          dataIndex: 'title',
          key: 'gszxTitle',
          ellipsis: true,
          slots: { customRender: 'link', type: 'url' },
          // customRender: ({ record }: any) => ({
          //   children: h('a', {
          //     href: record.url,
          //     target: '_blank',
          //     style: 'color: #aaaaaa; text-decoration: none;'
          //   }, record.title)
          // }),
        },
      ],
      total: 0,
      pageSize: 10, // 每页显示条数
      currentPage: 1, // 当前页码
      spinning: true,
    })

    // 本地分页计算当前页数据
    const pagedData = computed(() => {
      const start = (pageData.currentPage - 1) * pageData.pageSize
      const end = start + pageData.pageSize
      return pageData.allData.slice(start, end)
    })

    // 分页配置（使用 getter/setter 与状态双向绑定）
    const pagination = reactive({
      get total() {
        return pageData.total
      },
      get current() {
        return pageData.currentPage
      },
      set current(val: number) {
        pageData.currentPage = val
      },
      get pageSize() {
        return pageData.pageSize
      },
      set pageSize(val: number) {
        pageData.pageSize = val
      },
      showSizeChanger: true,
      showTotal: (total: number) => `共${total}条`,
      pageSizeOptions: ['10', '20', '50', '100'],
      onChange: (page: number, pageSize?: number) => {
        pageData.currentPage = page
        if (pageSize) pageData.pageSize = pageSize
      },
      onShowSizeChange: (current: number, size: number) => {
        pageData.currentPage = 1
        pageData.pageSize = size
      }
    })


    // 转换接口数据，补充 key
    function transformData(raw: any[]) {
      return raw.map((item, index) => ({
        ...item,
        key: item.news_id || index,
      }))
    }

    // 获取数据
    function fetchData() {
      pageData.spinning = true

      // 本地开发环境使用默认参数，否则用路由参数
      let market: string, symbol: string
      if (isLocalDev) {
        market = route.query.exchange as string || 'US'
        symbol = route.query.code as string || 'AAPL'
      } else {

        market = route.query.exchange as string
        // market = 'US'
        symbol = route.query.code as string
      }
      const symbols = `${symbol}.${market}`

      const data: any = {
        data: {
          symbols,
          type: '2',
          page: 1,
          page_size: 10000,
          token: props.token || '3d5eff0d3c7ac7f3af30c337dcdf6944',
        },
        headers: {},
      }

      f10ApiUS.getBriefAnnouncementsMg(data).then((res: any) => {
        if (res && res.data && Array.isArray(res.data.list)) {
          pageData.allData = transformData(res.data.list)
          pageData.total = pageData.allData.length
        } else {
          pageData.allData = []
          pageData.total = 0
        }
        pageData.spinning = false
      }).catch(() => {
        pageData.spinning = false
      })
    }

    onMounted(() => {
      fetchData()
    })

    return {
      ...toRefs(pageData),
      pagedData,
      pagination
    }
  },
})
